import React,{useEffect} from "react";
import { Link } from "react-router-dom";

import NavLight from "../components/navbar";
import Footer from "../components/footer";
import Switcher from "../components/switcher";

export default function Privacy(){
    useEffect(() => {
        document.documentElement.setAttribute("dir", "ltr");
        document.documentElement.classList.add('light');

      }, []);
    return(
        <>
        <NavLight/>
        <section className="relative md:pt-44 pt-32 pb-8 bg-gradient-to-b from-amber-400/20 dark:from-amber-400/40 to-transparent">
            <div className="container relative">
                <div className="grid grid-cols-1 text-center mt-6">
                    <div>
                        <h5 className="md:text-4xl text-3xl md:leading-normal leading-normal tracking-wider font-semibold mb-0">Privacy Policy</h5>
                    </div>

                    <ul className="tracking-[0.5px] mb-0 inline-block mt-5">
                    <li className="inline-block capitalize font-medium duration-500 ease-in-out hover:text-amber-400"><Link to="/">MinuAI</Link></li>
                    <li className="inline-block text-base mx-0.5 ltr:rotate-0 rtl:rotate-180"><i className="mdi mdi-chevron-right"></i></li>
                    <li className="inline-block capitalize font-medium duration-500 ease-in-out text-amber-400" aria-current="page">Privacy</li>
                </ul>
            </div>
        </div>
    </section>
    <section className="relative md:py-24 py-16">
        <div className="container relative">
            <div className="md:flex justify-center">
                <div className="md:w-3/4">
                    <div className="p-6 bg-white dark:bg-slate-900 shadow dark:shadow-gray-800 rounded-md">

                        <p className="text-slate-400">At MinuAI, we value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, share, and safeguard your data when you join our waitlist.</p>

                        <h5 className="text-xl font-semibold mb-4 mt-8">Information We Collect :</h5>
                        <p className="text-slate-400">When you sign up for the MinuAI waitlist, we collect the following personal information:</p>
                        <ul className="list-none text-slate-400 mt-4">
                            <li className="flex mt-2"><i className="mdi mdi-arrow-right text-amber-400 text-lg align-middle me-2"></i>Email Address</li>
                        </ul>

                        <h5 className="text-xl font-semibold mb-4 mt-8">How We Use Your Information :</h5>
                        <ul className="list-none text-slate-400 mt-4">
                            <li className="flex mt-2"><i className="mdi mdi-arrow-right text-amber-400 text-lg align-middle me-2"></i>Notify you about product updates, launch dates, and new features</li>
                            <li className="flex mt-2"><i className="mdi mdi-arrow-right text-amber-400 text-lg align-middle me-2"></i>Respond to your inquiries and provide support</li>
                            <li className="flex mt-2"><i className="mdi mdi-arrow-right text-amber-400 text-lg align-middle me-2"></i>Improve our services and understand our audience better</li>
                            <li className="flex mt-2"><i className="mdi mdi-arrow-right text-amber-400 text-lg align-middle me-2"></i>Comply with legal requirements</li>
                        </ul>

                        <h5 className="text-xl font-semibold mb-4 mt-8">Data Sharing and Disclosure :</h5>
                        <p className="text-slate-400">We do not sell, trade, or rent your personal information. However, we may share your data with trusted third-party service providers who assist us in managing our waitlist, email communication, or other operational tasks. These third parties are contractually obligated to protect your information.</p>

                        <h5 className="text-xl font-semibold mb-4 mt-8">Data Security :</h5>
                        <p className="text-slate-400">We implement reasonable security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.</p>

                        <h5 className="text-xl font-semibold mb-4 mt-8">Your Data Rights :</h5>
                        <p className="text-slate-400">Depending on your location, you may have the following rights regarding your personal information:</p>
                        <ul className="list-none text-slate-400 mt-4">
                            <li className="flex mt-2"><i className="mdi mdi-arrow-right text-amber-400 text-lg align-middle me-2"></i>Access, correct, or delete your personal information</li>
                            <li className="flex mt-2"><i className="mdi mdi-arrow-right text-amber-400 text-lg align-middle me-2"></i>Withdraw consent for data processing</li>
                            <li className="flex mt-2"><i className="mdi mdi-arrow-right text-amber-400 text-lg align-middle me-2"></i>Lodge a complaint with a data protection authority</li>
                        </ul>

                        <h5 className="text-xl font-semibold mb-4 mt-8">Cookies and Tracking Technologies :</h5>
                        <p className="text-slate-400">We may use cookies or similar technologies to enhance your experience on our website. You can manage your cookie preferences through your browser settings.</p>

                        <h5 className="text-xl font-semibold mb-4 mt-8">Changes to This Privacy Policy :</h5>
                        <p className="text-slate-400">We may update this policy from time to time. Any changes will be communicated through our website or via email.</p>

                        <p className="text-slate-400 mt-4">If you have any questions about this Privacy Policy, please contact us at: [Insert Contact Email]</p>

                        <div className="mt-8">
                            <Link to="" className="py-2 px-5 inline-block font-semibold tracking-wide border align-middle duration-500 text-base text-center bg-amber-400 hover:bg-amber-500 border-amber-400 hover:border-amber-500 text-white rounded-md">Print</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
        <Footer/>

        </>
    )
}